import React from 'react';

import styled from 'styled-components';

import { JRCLoader } from 'jamespot-react-components';

export const Wrapper = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.4);
`;

export const WidgetIsPending = () => {
    return (
        <Wrapper>
            <JRCLoader size={'m'} />
        </Wrapper>
    );
};
